import NewsItem from './NewsItem'
import './NewsItem.css'

export default NewsItem



// WEBPACK FOOTER //
// ./src/components/NewsItem/index.js